import { useCallback } from 'react';

import { useHeliosPermissions } from 'hooks/use-helios-permissions/useHeliosPermissions';
import {
  AutocompleteInput,
  AutocompleteInputProps,
  RaRecord,
  useGetIdentity,
  useGetList,
  useInput,
} from 'react-admin';
import { PermissionName, Scope } from 'types/permission.types';
import { Organization } from 'types/organizations.types';

export const OrganizationInput: React.FC<
  AutocompleteInputProps<Organization>
> = (props) => {
  const { field: hunterField } = useInput({ source: 'hunterId' });
  const { field: contactField } = useInput({ source: 'contactId' });
  const { getScope } = useHeliosPermissions();
  const { identity } = useGetIdentity();

  const { isLoading, isFetching, data } = useGetList<RaRecord>(
    'organizations',
    {
      sort: { field: 'name', order: 'ASC' },
    }
  );

  const getOptionDisabled = useCallback(
    (option: RaRecord) => {
      if (
        getScope(PermissionName.UpdateRealEstateTransferOwnership) ===
        Scope.Organization
      ) {
        return option.id !== identity?.organization;
      }
      return false;
    },
    [getScope, identity]
  );

  const handleOnChange = () => {
    hunterField.onChange('');
    contactField.onChange('');
  };

  return (
    <AutocompleteInput<Organization>
      {...props}
      choices={data?.sort((a, b) => {
        return a.name > b.name ? 1 : -1;
      })}
      isLoading={isLoading}
      isFetching={isFetching}
      onChange={handleOnChange}
      variant="outlined"
      getOptionDisabled={getOptionDisabled}
    />
  );
};
